/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { baseRecommendationItemRequestSchema } from "./baseRecommendationItemRequestSchema.ts";

export const baseRecommendationSourceRequestSchema = z
	.object({
		id: z.uuid().nullish(),
		external_id: z.uuid().nullish(),
		recommendations: z.array(baseRecommendationItemRequestSchema),
	})
	.describe("Базовый сериализатор для исходной сущности (группа или продукт).");
